import { render } from "./Patients.vue?vue&type=template&id=5ab1547e"
import script from "./Patients.vue?vue&type=script&lang=js"
export * from "./Patients.vue?vue&type=script&lang=js"

import exportComponent from "../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__